interface NcmCatalogoItem {
  id: number;
  ncm: string;
  descricao: string | null;
  jaCadastrado?: boolean;
}

export interface NcmCatalogoOption {
  id: number;
  name: string;
  ncm: string;
  descricao: string | null;
}

const ehItemCatalogo = (v: unknown): v is NcmCatalogoItem =>
  typeof v === 'object' &&
  v !== null &&
  'id' in v &&
  typeof v.id === 'number' &&
  'ncm' in v &&
  typeof v.ncm === 'string' &&
  (!('descricao' in v) || v.descricao === null || typeof v.descricao === 'string');

const rotulo = (ncm: string, descricao: string | null) => (descricao ? `${ncm} · ${descricao}` : ncm);

// Busca no catálogo oficial global; NCM só é selecionado, nunca criado.
export const ncmCatalogoEndpoint = {
  listPath: '/backend/ncm/catalogo',
  searchParam: 'q',
  transformResponse: (data: unknown): NcmCatalogoOption[] =>
    (Array.isArray(data) ? data.filter(ehItemCatalogo) : []).map((item) => ({
      id: item.id,
      name: `${rotulo(item.ncm, item.descricao)}${item.jaCadastrado ? ' · em uso' : ''}`,
      ncm: item.ncm,
      descricao: item.descricao,
    })),
};

export const codigoNcmDe = (produto: object): string | undefined => {
  if ('Ncm' in produto && typeof produto.Ncm === 'object' && produto.Ncm !== null && 'ncm' in produto.Ncm && typeof produto.Ncm.ncm === 'string') {
    return produto.Ncm.ncm;
  }
  return 'ncm' in produto && typeof produto.ncm === 'string' ? produto.ncm : undefined;
};

export const ncmSelecionado = (id: number | null | undefined, ncm: string | null | undefined): NcmCatalogoOption | null =>
  id ? { id, name: ncm ?? String(id), ncm: ncm ?? '', descricao: null } : null;

export const ncmDaOpcao = (option: { id: unknown; name: string } | null): NcmCatalogoOption | null => {
  if (!option) return null;
  return {
    id: Number(option.id),
    name: option.name,
    ncm: 'ncm' in option && typeof option.ncm === 'string' ? option.ncm : option.name,
    descricao: 'descricao' in option && typeof option.descricao === 'string' ? option.descricao : null,
  };
};
